export class PartitionCandidate {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "string",
            "format": ""
        },
        {
            "name": "transformSuggestion",
            "baseName": "transformSuggestion",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PartitionCandidate.attributeTypeMap;
    }
    constructor() {
    }
}
